import { mapGetters } from 'vuex'
import boxContainer from '@/components/box-container.vue'
import contentLayout from '@/layout/content-layout.vue'
import saveConfirmMixin from '@/mixins/save-confirm.js'
import tableRowSelectMixin from '@/mixins/table-row-select.js'
import operateButton from '@/components/operate-button.vue'
import moment from 'moment'
import reg from '@/utils/reg.js'
import common from '@/utils/common.js'

const $priceFixed = 4
const $moneyFixed = 2
const $qtyFixed = 4

export default {
  components: {
    'box-container': boxContainer,
    'content-layout': contentLayout,
    'operate-button': operateButton
  },
  mixins: [saveConfirmMixin, tableRowSelectMixin],
  data () {
    return {
      g_priceFixed: $priceFixed,
      g_moneyFixed: $moneyFixed,
      g_qtyFixed: $qtyFixed,
      g_reg: reg
    }
  },
  methods: {
    $_g_hasPermission (_permission) {
      var has = false
      if (this.permissions && this.permissions.length > 0) {
        has = this.permissions.some((item, index, array) => {
          return item.code === _permission
        })
      }
      return has
    },
    $_g_apiCallback (promise, successed, failed, finale) {
      var vm = this
      promise
      .then((rs) => {
        if (rs.status) {
          if (rs.status === 200) {
            vm.$message({
              message: '成功',
              type: 'success'
            })
            if (successed) {
              successed(rs)
            }
          } else {
            if (rs.message.length > 0) {
              vm.$alert(rs.message, '失败', {
                confirmButtonText: '关闭',
                type: 'error'
              })
            }
            if (failed) {
              failed(rs)
            }
          }
        } else {
          if (successed) {
            successed(rs)
          }
        }
        if (finale) {
          finale(rs)
        }
      })
      .catch(error => {
        var msg = error.response ? error.response.data.message : (error.message || '')
        if (error.response.status !== 401) {
          vm.$alert(msg, '错误', {
            confirmButtonText: '关闭',
            type: 'error'
          })
        }
        if (failed) {
          failed(error)
        }
        if (finale) {
          finale(error)
        }
      })
    },
    $_g_clone (item) {
      if (item === null || item === undefined) {
        return item
      }
      switch (common.getTypeStr(item)) {
        case 'array':
          return common.objectDeepCopy(item)
        case 'object':
          return common.objectDeepCopy(item)
        default:
          return item
      }
    },
    $_g_formatPriceColumn (row, column, cellValue) {
      return this.$_g_formatPrice(cellValue)
    },
    $_g_formatMoneyColumn (row, column, cellValue) {
      return this.$_g_formatMoney(cellValue)
    },
    $_g_formatQtyColumn (row, column, cellValue) {
      return this.$_g_formatQty(cellValue)
    },
    $_g_formatDateColumn (row, column, cellValue) {
      return moment(cellValue).format('YYYY-MM-DD')
    },
    $_g_formatMonthColumn (row, column, cellValue) {
      return moment(cellValue).format('YYYY-MM')
    },
    $_g_formatBoolColumn (row, column, cellValue) {
      return cellValue ? '是' : '否'
    },
    $_g_formatRateColumn (row, column, cellValue) {
      return cellValue + ' %'
    },
    //
    $_g_formatPrice (value) {
      return Number(value).toFixed($priceFixed)
    },
    $_g_formatMoney (value) {
      return Number(value).toFixed($moneyFixed)
    },
    $_g_formatQty (value) {
      return Number(value).toFixed($qtyFixed)
    },
    $_g_formatRate (value) {
      return value + ' %'
    },
    $_g_formatInUse (value) {
      return value ? '启用' : '禁用'
    },
    $_g_formatDate (value) {
      return moment(value).format('YYYY-MM-DD')
    },
    $_g_formatMonth (value) {
      return moment(value).format('YYYY-MM')
    },
    $_g_formatTimestamp (value) {
      return moment(value).format('YYYYMMDDHHmmss')
    }
  },
  filters: {
    $_g_formatRate (value) {
      return value + ' %'
    },
    $_g_formatPrice (value) {
      return Number(value).toFixed($priceFixed)
    },
    $_g_formatMoney (value) {
      return Number(value).toFixed($moneyFixed)
    },
    $_g_formatQty (value) {
      return Number(value).toFixed($qtyFixed)
    },
    $_g_formatInUse (value) {
      return value ? '启用' : '禁用'
    }
  },
  computed: {
    ...mapGetters([
      'permissions',
      'currentUser',
      'configs'
    ]),
    $permissionKey () {
      return this.$route.meta.permissions
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/global.js